// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Background Colors */
  --color-bg-app: #fafafa;
  --color-bg-surface: #ffffff;
  --color-bg-active: #dbeafe;
  --color-bg-hover: #f9fafb;

  /* Border Colors */
  --color-border-default: #e5e5e5;
  --color-border-subtle: #f0f0f0;
  --color-border-divider: #e5e5e5;

  /* Text Colors */
  --color-text-primary: #171717;
  --color-text-secondary: #737373;
  --color-text-muted: #a3a3a3;
  --color-text-inverse: #ffffff;

  /* Primary Brand Color */
  --color-primary: #3b82f6;
  --color-primary-hover: #2563eb;
  --color-primary-text: #3b82f6;

  /* Priority Colors */
  --color-priority-p1: #ef4444;
  --color-priority-p2: #f59e0b;
  --color-priority-p3: #3b82f6;
  --color-priority-p4: #737373;

  /* Tag Colors (Light Theme) */
  --color-tag-work-bg: #eff6ff;
  --color-tag-work-border: #3b82f6;
  --color-tag-work-text: #3b82f6;

  --color-tag-personal-bg: #f0fdf4;
  --color-tag-personal-border: #10b981;
  --color-tag-personal-text: #10b981;

  --color-tag-urgent-bg: #fff7ed;
  --color-tag-urgent-border: #f59e0b;
  --color-tag-urgent-text: #f59e0b;

  --color-tag-important-bg: #faf5ff;
  --color-tag-important-border: #8b5cf6;
  --color-tag-important-text: #8b5cf6;

  /* Badge Colors */
  --color-badge-due-today-bg: #fef2f2;
  --color-badge-due-today-border: #ffc9c9;
  --color-badge-due-today-text: #dc2626;

  --color-badge-recurrence-bg: #faf5ff;
  --color-badge-recurrence-border: #e9d4ff;
  --color-badge-recurrence-text: #9810fa;

  /* State Colors */
  --color-completed-text: #a3a3a3;
  --color-checkbox-checked: #3b82f6;

  /* Semantic Colors */
  --color-success: #10b981;
  --color-error: #ef4444;
  --color-warning: #f59e0b;

  /* Typography */
  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;

  /* Font Sizes */
  --font-size-xs: 12px;
  --font-size-sm: 14px;
  --font-size-base: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 24px;

  /* Line Heights */
  --line-height-tight: 1.2;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;

  /* Spacing Scale */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 12px;
  --spacing-lg: 16px;
  --spacing-xl: 24px;
  --spacing-2xl: 32px;

  /* Border Radius */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-full: 9999px;

  /* Layout Dimensions */
  --sidebar-width: 256px;
  --details-panel-width: 384px;

  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-base: 200ms ease;
  --transition-slow: 300ms ease;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-modal: 0 20px 25px rgba(0, 0, 0, 0.15);
}

[data-theme="dark"] {
  /* Background Colors */
  --color-bg-app: #0a0a0a;
  --color-bg-surface: #171717;
  --color-bg-active: #1e3a5f;
  --color-bg-hover: #262626;

  /* Border Colors */
  --color-border-default: #404040;
  --color-border-subtle: #2a2a2a;
  --color-border-divider: #404040;

  /* Text Colors */
  --color-text-primary: #fafafa;
  --color-text-secondary: #a3a3a3;
  --color-text-muted: #737373;
  --color-text-inverse: #171717;

  /* Primary Brand Color (same) */
  --color-primary: #3b82f6;
  --color-primary-hover: #2563eb;
  --color-primary-text: #3b82f6;

  /* Priority Colors (same) */
  --color-priority-p1: #ef4444;
  --color-priority-p2: #f59e0b;
  --color-priority-p3: #3b82f6;
  --color-priority-p4: #737373;

  /* Tag Colors (Dark Theme - adjusted backgrounds) */
  --color-tag-work-bg: #eff6ff;
  --color-tag-work-border: #3b82f6;
  --color-tag-work-text: #3b82f6;

  --color-tag-personal-bg: #f0fdf4;
  --color-tag-personal-border: #10b981;
  --color-tag-personal-text: #10b981;

  --color-tag-urgent-bg: #fff7ed;
  --color-tag-urgent-border: #f59e0b;
  --color-tag-urgent-text: #f59e0b;

  --color-tag-important-bg: #faf5ff;
  --color-tag-important-border: #8b5cf6;
  --color-tag-important-text: #8b5cf6;

  /* Badge Colors */
  --color-badge-due-today-bg: #fef2f2;
  --color-badge-due-today-border: #ffc9c9;
  --color-badge-due-today-text: #dc2626;

  --color-badge-recurrence-bg: #faf5ff;
  --color-badge-recurrence-border: #e9d4ff;
  --color-badge-recurrence-text: #9810fa;

  /* State Colors */
  --color-completed-text: #a3a3a3;
  --color-checkbox-checked: #3b82f6;

  /* Semantic Colors (same) */
  --color-success: #10b981;
  --color-error: #ef4444;
  --color-warning: #f59e0b;

  /* Shadows - darker for dark theme */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);
  --shadow-modal: 0 20px 25px rgba(0, 0, 0, 0.6);
}

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

/* opinionated globals */

button {
  border: none;
}

button:hover {
  cursor: pointer;
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

a,
a:visited {
  text-decoration: none;
}

/* base styles */

body {
  font-family: var(--font-family-base);
  background-color: var(--color-bg-app);
  color: var(--color-text-primary);
  height: 100%;
  margin: 0;
}

body {
  line-height: var(--line-height-normal);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
}

/* Typography */
h1 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}

h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}

h3 {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-muted);
}

/* Utility Classes */
.text-secondary {
  color: var(--color-text-secondary);
}

.text-muted {
  color: var(--color-text-muted);
}

/* Focus Styles */
button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Transitions */
button,
a {
  transition: all var(--transition-fast);
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;;EAEzB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;;EAE/B,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;;EAE7B,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;;EAE7B,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;;EAE9B,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;;EAElC,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;;EAEhC,iCAAiC;EACjC,qCAAqC;EACrC,mCAAmC;;EAEnC,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,qCAAqC;;EAErC,oCAAoC;EACpC,wCAAwC;EACxC,sCAAsC;;EAEtC,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;;EAEjC,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;;EAExB,eAAe;EACf,8FAA8F;EAC9F,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;;EAE3B,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;;EAEpB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;;EAE3B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;;EAE5B,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;;EAEzB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;;EAE/B,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;;EAE7B,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;;EAE7B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,mDAAmD;EACnD,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;;EAE9B,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;;EAElC,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;;EAEhC,iCAAiC;EACjC,qCAAqC;EACrC,mCAAmC;;EAEnC,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,qCAAqC;;EAErC,oCAAoC;EACpC,wCAAwC;EACxC,sCAAsC;;EAEtC,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;;EAEjC,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;;EAExB,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,gBAAgB;;AAEhB;EACE,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;;;;EAIE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;;EAEE,sCAAsC;AACxC","sourcesContent":[":root {\n  /* Background Colors */\n  --color-bg-app: #fafafa;\n  --color-bg-surface: #ffffff;\n  --color-bg-active: #dbeafe;\n  --color-bg-hover: #f9fafb;\n\n  /* Border Colors */\n  --color-border-default: #e5e5e5;\n  --color-border-subtle: #f0f0f0;\n  --color-border-divider: #e5e5e5;\n\n  /* Text Colors */\n  --color-text-primary: #171717;\n  --color-text-secondary: #737373;\n  --color-text-muted: #a3a3a3;\n  --color-text-inverse: #ffffff;\n\n  /* Primary Brand Color */\n  --color-primary: #3b82f6;\n  --color-primary-hover: #2563eb;\n  --color-primary-text: #3b82f6;\n\n  /* Priority Colors */\n  --color-priority-p1: #ef4444;\n  --color-priority-p2: #f59e0b;\n  --color-priority-p3: #3b82f6;\n  --color-priority-p4: #737373;\n\n  /* Tag Colors (Light Theme) */\n  --color-tag-work-bg: #eff6ff;\n  --color-tag-work-border: #3b82f6;\n  --color-tag-work-text: #3b82f6;\n\n  --color-tag-personal-bg: #f0fdf4;\n  --color-tag-personal-border: #10b981;\n  --color-tag-personal-text: #10b981;\n\n  --color-tag-urgent-bg: #fff7ed;\n  --color-tag-urgent-border: #f59e0b;\n  --color-tag-urgent-text: #f59e0b;\n\n  --color-tag-important-bg: #faf5ff;\n  --color-tag-important-border: #8b5cf6;\n  --color-tag-important-text: #8b5cf6;\n\n  /* Badge Colors */\n  --color-badge-due-today-bg: #fef2f2;\n  --color-badge-due-today-border: #ffc9c9;\n  --color-badge-due-today-text: #dc2626;\n\n  --color-badge-recurrence-bg: #faf5ff;\n  --color-badge-recurrence-border: #e9d4ff;\n  --color-badge-recurrence-text: #9810fa;\n\n  /* State Colors */\n  --color-completed-text: #a3a3a3;\n  --color-checkbox-checked: #3b82f6;\n\n  /* Semantic Colors */\n  --color-success: #10b981;\n  --color-error: #ef4444;\n  --color-warning: #f59e0b;\n\n  /* Typography */\n  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-weight-regular: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n\n  /* Font Sizes */\n  --font-size-xs: 12px;\n  --font-size-sm: 14px;\n  --font-size-base: 16px;\n  --font-size-lg: 18px;\n  --font-size-xl: 24px;\n\n  /* Line Heights */\n  --line-height-tight: 1.2;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n\n  /* Spacing Scale */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 12px;\n  --spacing-lg: 16px;\n  --spacing-xl: 24px;\n  --spacing-2xl: 32px;\n\n  /* Border Radius */\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-full: 9999px;\n\n  /* Layout Dimensions */\n  --sidebar-width: 256px;\n  --details-panel-width: 384px;\n\n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-base: 200ms ease;\n  --transition-slow: 300ms ease;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-modal: 0 20px 25px rgba(0, 0, 0, 0.15);\n}\n\n[data-theme=\"dark\"] {\n  /* Background Colors */\n  --color-bg-app: #0a0a0a;\n  --color-bg-surface: #171717;\n  --color-bg-active: #1e3a5f;\n  --color-bg-hover: #262626;\n\n  /* Border Colors */\n  --color-border-default: #404040;\n  --color-border-subtle: #2a2a2a;\n  --color-border-divider: #404040;\n\n  /* Text Colors */\n  --color-text-primary: #fafafa;\n  --color-text-secondary: #a3a3a3;\n  --color-text-muted: #737373;\n  --color-text-inverse: #171717;\n\n  /* Primary Brand Color (same) */\n  --color-primary: #3b82f6;\n  --color-primary-hover: #2563eb;\n  --color-primary-text: #3b82f6;\n\n  /* Priority Colors (same) */\n  --color-priority-p1: #ef4444;\n  --color-priority-p2: #f59e0b;\n  --color-priority-p3: #3b82f6;\n  --color-priority-p4: #737373;\n\n  /* Tag Colors (Dark Theme - adjusted backgrounds) */\n  --color-tag-work-bg: #eff6ff;\n  --color-tag-work-border: #3b82f6;\n  --color-tag-work-text: #3b82f6;\n\n  --color-tag-personal-bg: #f0fdf4;\n  --color-tag-personal-border: #10b981;\n  --color-tag-personal-text: #10b981;\n\n  --color-tag-urgent-bg: #fff7ed;\n  --color-tag-urgent-border: #f59e0b;\n  --color-tag-urgent-text: #f59e0b;\n\n  --color-tag-important-bg: #faf5ff;\n  --color-tag-important-border: #8b5cf6;\n  --color-tag-important-text: #8b5cf6;\n\n  /* Badge Colors */\n  --color-badge-due-today-bg: #fef2f2;\n  --color-badge-due-today-border: #ffc9c9;\n  --color-badge-due-today-text: #dc2626;\n\n  --color-badge-recurrence-bg: #faf5ff;\n  --color-badge-recurrence-border: #e9d4ff;\n  --color-badge-recurrence-text: #9810fa;\n\n  /* State Colors */\n  --color-completed-text: #a3a3a3;\n  --color-checkbox-checked: #3b82f6;\n\n  /* Semantic Colors (same) */\n  --color-success: #10b981;\n  --color-error: #ef4444;\n  --color-warning: #f59e0b;\n\n  /* Shadows - darker for dark theme */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);\n  --shadow-modal: 0 20px 25px rgba(0, 0, 0, 0.6);\n}\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n*:not(dialog) {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* opinionated globals */\n\nbutton {\n  border: none;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\nul {\n  padding: 0;\n}\n\nli {\n  list-style: none;\n}\n\na,\na:visited {\n  text-decoration: none;\n}\n\n/* base styles */\n\nbody {\n  font-family: var(--font-family-base);\n  background-color: var(--color-bg-app);\n  color: var(--color-text-primary);\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  line-height: var(--line-height-normal);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-regular);\n}\n\n/* Typography */\nh1 {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-tight);\n}\n\nh2 {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-tight);\n}\n\nh3 {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-muted);\n}\n\n/* Utility Classes */\n.text-secondary {\n  color: var(--color-text-secondary);\n}\n\n.text-muted {\n  color: var(--color-text-muted);\n}\n\n/* Focus Styles */\nbutton:focus-visible,\ninput:focus-visible,\ntextarea:focus-visible,\nselect:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n/* Transitions */\nbutton,\na {\n  transition: all var(--transition-fast);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
